import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs/operators';

import { ReminderActions } from '../actions';
import { ReminderHttpService } from '../../services';

@Injectable()
export class ReminderEffects {

    postReminderEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<ReminderActions.PostReminder>(ReminderActions.ActionTypes.POST_REMINDER),
        switchMap((action: ReminderActions.PostReminder) => {
            return this.reminderHttpService.postReminder(action.payload).pipe(
                map((response) => {
                    return new ReminderActions.PostReminderSuccess(response);
                }),
                catchError((error: any) => {
                    return of(new ReminderActions.PostReminderFailure(error));
                })
            );
        })
    ));

    getReminderEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<ReminderActions.GetReminder>(ReminderActions.ActionTypes.GET_REMINDER),
        switchMap((action: ReminderActions.GetReminder) => {
            return this.reminderHttpService.getReminder(action.id, action.query).pipe(
                map((response) => {
                    return new ReminderActions.GetReminderSuccess(response);
                }),
                catchError((error: any) => {
                    return of(new ReminderActions.GetReminderFailure(error));
                })
            );
        })
    ));

    constructor(
        private actions$: Actions,
        private reminderHttpService: ReminderHttpService
    ) { }
}